import { useEffect, useState } from 'react'
import { useStore } from './context'
import { useObserver } from 'mobx-react-lite'

const useCommunityListData = (data, route) => {
	const store = useStore()

	useObserver(() => {
		const {
			uiStore: { community__activeTab, updateCommunityListData },
		} = store

		if (community__activeTab !== null) {
			switch (community__activeTab.label) {
				case 'Business':
					updateCommunityListData(data.businesses)
					break
				case 'Contributor':
					updateCommunityListData(data.contributors)
					break
				case 'Collaborator':
					updateCommunityListData(data.collaborators)
					break
				case 'Resources':
					updateCommunityListData(data.resources)
					break
				default:
					updateCommunityListData([])
					break
			}
		}
	})
}

export default useCommunityListData
